import React from 'react'
import styled from 'styled-components'

const ButtonWrapper = styled.button`
  background-color: ${({ theme }) => theme.colors.primaryButton};
  border-radius: ${({ theme }) => theme.standardRadius};
  border: 0;
  color: ${({ theme }) => theme.colors.primaryButtonText};
  font-weight: 500;
  margin-top: 16px !important;
  padding: 4px 10px;
  white-space: nowrap;
  z-index: 52;
`

const UserFeedBackLink = ({ T, clickHandler, style }) => {
  return (
    <ButtonWrapper aria-labelledby='feedbackLink' data-cy='userFeedbackLink' onClick={clickHandler}>
      {T('userFeedback:Feedback')}
    </ButtonWrapper>
  )
}

export default UserFeedBackLink
